// src/features/fb/shampoo/playbook/ShampooPlayBook.jsx
// Shampoo-specific PlayBook configuration component

import React from "react";
import { Box } from "@mui/material";
import PlayBookSection from "../../../../shared/sections/PlayBookSection";

/**
 * ShampooPlayBook - Shampoo commodity-specific playbook configuration
 * Wraps PlayBookSection with Shampoo-specific options and defaults
 */
export default function ShampooPlayBook({ data, onChange }) {
  // Shampoo-specific packaging options
  const primaryPackagingOptions = [
    "Plastic Bottle (HDPE)",
    "Plastic Bottle (PET)",
    "Sachet Pouch",
    "Glass Bottle",
    "Aluminum Bottle",
    "Tube",
    "Pump Bottle",
  ];

  const secondaryPackagingOptions = [
    "Carton Box",
    "Shrink Wrap",
    "Display Tray",
    "Sleeve Wrapper",
    "Master Carton",
  ];

  const tertiaryPackagingOptions = [
    "Pallet",
    "Shipping Container",
    "Corrugated Box",
    "Wooden Crate",
  ];

  // Shampoo-specific storage and regulatory options
  const storageConditionsOptions = [
    "Room Temperature",
    "Cool & Dry",
    "Climate Controlled",
    "Away from Direct Sunlight",
  ];

  const regulatoryOptions = [
    "FDA",
    "GMP",
    "ISO 22716 (Cosmetics)",
    "EU Cosmetics Regulation",
    "FSSAI (Personal Care)",
    "BIS (Bureau of Indian Standards)",
    "Cruelty-Free Certified",
    "Vegan Certified",
    "Organic Certified",
  ];

  // Shampoo-specific slider ranges (adjusted for liquid cosmetics)
  const ranges = {
    moisture: { min: 60, max: 85, step: 0.5 }, // Shampoo is mostly water (70-80%)
    process: { min: 0, max: 8, step: 0.5 }, // Lower process loss for liquids
    packaging: { min: 0, max: 3, step: 0.5 }, // Lower packaging loss for bottled products
    ohp: { min: 10, max: 40, step: 0.5 }, // Higher OHP for cosmetics (branding, marketing)
  };

  return (
    <Box>
      <PlayBookSection
        data={data}
        onChange={onChange}
        ranges={ranges}
        primaryPackagingOptions={primaryPackagingOptions}
        secondaryPackagingOptions={secondaryPackagingOptions}
        tertiaryPackagingOptions={tertiaryPackagingOptions}
        storageConditionsOptions={storageConditionsOptions}
        regulatoryOptions={regulatoryOptions}
      />
    </Box>
  );
}
